import { Link } from "react-router-dom";
import { catStyle } from "@/lib/api";
import { getToolIcon } from "@/lib/toolIcons";

export function ToolCard({ tool }) {
  const Icon = getToolIcon(tool.id, tool.category);
  return (
    <Link
      to={`/tool/${tool.id}`}
      data-testid={`tool-card-${tool.id}`}
      className="group relative flex flex-col rounded-xl border border-border bg-card p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,85,255,0.08)]"
    >
      <div className="mb-4 flex items-center justify-between">
        <div className={`inline-flex h-10 w-10 items-center justify-center rounded-lg ${catStyle(tool.category)} transition-transform group-hover:scale-110`}>
          <Icon className="h-5 w-5" strokeWidth={1.8} />
        </div>
        {!tool.functional && (
          <span className="label-mono rounded-full border border-border px-2 py-0.5 text-[10px]">
            Soon
          </span>
        )}
      </div>
      <h3 className="font-cabinet text-base font-semibold tracking-tight text-foreground">
        {tool.name}
      </h3>
      <p className="mt-1 font-plex text-sm leading-relaxed text-muted-foreground line-clamp-2">
        {tool.desc}
      </p>
    </Link>
  );
}
